export const cohortFieldDictionaryRoute = {
  path: 'field-dictionary',
  name: 'CohortFieldDictionary',
  component: () => import('@/components/FieldDictionary.vue')
}
